// src/contexts/ConfigContext.jsx
import React, { createContext, useReducer, useMemo } from 'react';

const initialState = {
  drawerOpen: true,  // Default: Sidebar open
  miniDrawer: false, // Default: Full width
  menuOrientation: 'vertical', // From your config.js (if exists)
  i18n: 'en'  // NEW: Default locale—fixes root cause
  // Expandable: Add theme, RTL, etc.
  // theme: 'light',
  // rtlLayout: false,
};

const configReducer = (state, action) => {
  switch (action.type) {
    case 'DRAWER_TOGGLE':
      return { ...state, drawerOpen: action.open };
    case 'MINI_DRAWER_TOGGLE':
      return { ...state, miniDrawer: action.mini };
    // Add more cases: e.g., 'THEME_TOGGLE': return { ...state, theme: action.theme };
    default:
      return state;
  }
};

export const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [state, dispatch] = useReducer(configReducer, initialState);
  const contextValue = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  );
};